import {
  pushActionResponseSchema,
  pushDeviceListResponseSchema,
  pushSubscribeRequestSchema,
  pushUnsubscribeCurrentRequestSchema,
  pushVapidPublicKeyResponseSchema,
  type PushSubscribeRequest,
} from '@gb-ticket/shared-types';

import { apiFetch } from '@/lib/api';

import { detectPlatformHint } from './push-support';

export function fetchPushVapidPublicKey() {
  return apiFetch('/notifications/push/vapid-public-key', pushVapidPublicKeyResponseSchema);
}

export function fetchPushDevices() {
  return apiFetch('/notifications/push/devices', pushDeviceListResponseSchema);
}

export function postPushSubscribe(subscription: PushSubscribeRequest) {
  return apiFetch('/notifications/push/subscribe', pushActionResponseSchema, {
    method: 'POST',
    body: JSON.stringify(subscription),
  });
}

export function deletePushDevice(deviceId: string) {
  return apiFetch(`/notifications/push/subscribe/${deviceId}`, pushActionResponseSchema, {
    method: 'DELETE',
  });
}

export function postPushUnsubscribeCurrent(endpoint: string) {
  return apiFetch('/notifications/push/unsubscribe-current', pushActionResponseSchema, {
    method: 'POST',
    body: JSON.stringify(pushUnsubscribeCurrentRequestSchema.parse({ endpoint })),
  });
}

export function postPushTest() {
  return apiFetch('/notifications/push/test', pushActionResponseSchema, {
    method: 'POST',
    body: JSON.stringify({}),
  });
}

/** Maps a browser PushSubscription JSON to the backend subscribe body. */
export function browserSubscriptionToRequest(
  subscription: PushSubscriptionJSON,
): PushSubscribeRequest {
  if (!subscription.endpoint || !subscription.keys?.p256dh || !subscription.keys.auth) {
    throw new Error('Push subscription is incomplete.');
  }
  return pushSubscribeRequestSchema.parse({
    endpoint: subscription.endpoint,
    keys: {
      p256dh: subscription.keys.p256dh,
      auth: subscription.keys.auth,
    },
    expirationTime: subscription.expirationTime ?? null,
    userAgent: navigator.userAgent.slice(0, 512),
    platformHint: detectPlatformHint(),
  });
}
